// 查询信息
const airParams = require(`@/lib/data-service/flight/flight_domestic_buyer_white_order_reserve_params`);
// 手续费查询
const rate = require(`@/lib/data-service/flight/flight_platform_commission_rate`);
// 提交订单
const reserve = require(`@/lib/data-service/flight/flight_domestic_buyer_white_order_reserve`);
import {ProcurementRuleText} from "@/page/distributor/air-ticket/ProcurementRule.js";
import ChangClause from "@/page/distributor/air-ticket/components/changClause.vue";
import rule from "@/lib/data-service/flight/newFligthApi/buyer_dom_white_rule";
import luggage from "@/lib/data-service/flight/buyer_dom_white_luggage";
import adultTicket from "@/lib/data-service/flight/buyer_dom_white_adultTicket";
import airStop from "@/page/distributor/air-ticket/components/airStop.vue";
import priceDetail from "@/lib/data-service/flight/buyer_dom_manage_order_price_detail";
import verification from "@/lib/deprecated/utils/verification/1.0.0";
import web_tUsfrequenttraveller_listForOrder from "@/lib/data-service/default/web_tUsfrequenttraveller_listForOrder";
import web_tUsfrequenttraveller_saveOrUpdate from "@/lib/data-service/default/web_tUsfrequenttraveller_saveOrUpdate";
import FlightFrequentTravelerSelector
    from 'yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/flight-frequent-traveler-selector/1.0.0/index.vue';
import debounce from '@/lib/deprecated/utils/debounce'
import moment from "moment";
import { awaitWrap } from "@/page/distributor/train/front/common/unit";
import { Loading } from 'element-ui';


export default {
    data() {
        const v_model_idCard = (rule, value, callback) => {
            let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (reg.test(value) === false) {
                callback(new Error("请输入正确身份证号码"));
            }
            let birthday = ''
            if (value.length === 15) {
                birthday = "19" + value.substr(6, 6);
            } else if (value.length === 18) {
                birthday = value.substr(6, 8);
            }
            birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
            let birthdayArr = birthday.split('-')
            let yearSubmit = parseInt(birthdayArr[0]) !== NaN && parseInt(birthdayArr[0]) >= 1900
            let monthSubmit = parseInt(birthdayArr[1]) !== NaN && parseInt(birthdayArr[1]) >= 1 && parseInt(birthdayArr[1]) <= 12
            let daySubmit = parseInt(birthdayArr[2]) !== NaN && parseInt(birthdayArr[2]) >= 1 && parseInt(birthdayArr[2]) <= 31
            if (!yearSubmit || !monthSubmit || !daySubmit) {
                callback(new Error("请输入正确身份证号码"));
            }
        };
        const v_model_name = (rule, value, callback) => {
            let reg = /^[0-9]+.?[0-9]*$/;
            let pinyin = /^[A-Za-z]+$/;
            let Chinese = /^[\u4e00-\u9fa5]+$/;
            if (!value) {
                callback(new Error("请输入乘机人姓名"));
            } else if (reg.test(value)) {
                callback(new Error("输入姓名有误！"));
            } else if (Chinese.test(value) && value.length > 12) {
                callback(new Error("中文名字最大输入12位"));
            } else if (pinyin.test(value)) {
                if (value.indexOf("/") === -1) {
                    callback(new Error("英文名字加上'/'分隔"));
                }
            } else {
                callback(verification.verifySpace(value));
            }
        };
        return {
            v_model_idCard_rules: v_model_idCard,
            // 常旅客表格列表
            tableData: [],
            tableDataFilter: [], // 过滤的常旅客table
            // 选择常旅客查詢參數
            searchDate: { // 常旅客 search 参数
                name: '',
                idType: '',
                idCard: '',
            },
            pageData: { // 常旅客 分页 参数
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            multipleSelection: [],
            dialogTableVisible: false,


            // 航班信息
            ordersData: [],
            alertingText: {
                child: [
                    "1.年龄：2岁（含）-12岁（不含）可购买儿童票；",
                    "2.儿童需在成人的陪同下乘机；无陪儿童请拨打航空公司确认是否可以购买；",
                    "3.请确认乘机人与证件上姓名相同，否则无法登机，英文名请在姓与名之间加 / ,比如ZHOU/LEI。",
                    "4.预定儿童时，需正确填写成人的信息，儿童和成人必须乘坐相同航班、日期，出发地和目的地。",
                    "5.儿童需要成人陪同。一名成人旅客（满18周岁）仅可携带两名儿童旅客，超过儿童需要直接至航空公司柜台申请购买无成人陪伴儿童客票。",
                    "6.乘机证件：身份证，户口本，护照。",
                    "7.如大人退改签，儿童必须一起操作退改签，否则航司拒绝登机，我司不承担责任"
                ],
                aduit: [
                    " 1、请确认乘机人姓名与证件上姓名相同，否则无法登机。英文名请在姓与名之间加“/”,如“zhou/jielun”",
                    "2、预定儿童时，需正确填写成人信息，儿童和成人必须乘坐相同航班、相同舱位等级。",
                    "3、儿童、婴儿须有成人陪同，一名成人旅客仅可携带两名儿童旅客，超过儿童需直接至航空公司柜台申请购买无成人陪伴儿童客票。",
                    "4、儿童需预定Y舱，系统会名字后自动添加CHD，只享受儿童返点。",
                    "5、订单生成：您下单生成订单后，不得随意变更订座记录信息，若有变更必须重新下订单。",
                    "6、根据航空公司规定，分销商应准确录入客户手机号，多个乘客多个号码，不可重复，如出现多个乘机人同个号码，系统无法提交出票，请悉知！"
                ]
            },
            // 乘客数量
            passengerVal: 0,
            loading: false,
            // 乘客类型
            psgTypeOption: [
                {value: 1, label: "成人", disabled: false},
                {value: 2, label: "儿童", disabled: false}
            ],
            // 联系人信息
            contact: {
                contactEmail: "",
                contactName: "",
                remark: "",
                contactPhone: ""
            },
            ProcurementRuleText: ProcurementRuleText,
            // 旅客证件
            cardType: [
                {value: 1, name: "身份证"},
                {value: 2, name: "护照"},
                // {value: 2, name: ''},
                // {value: 3, name: '身份证'},
                {value: 4, name: "港澳通行证"},
                {value: 5, name: "台胞证"},
                {value: 6, name: "台湾通行证"},
                {value: 7, name: "回乡证"},
                {value: 8, name: "军官证"},
                {value: 9, name: "其他"}
            ],
            airDataInfo: {},
            // 是否同意胤之旅规则
            checked: false,
            warningShow: false,
            // 乘客信息
            passenger: [],
            ProcurementRuleShow: false,
            // 乘客类型
            psgType: 3,
            // 输入框验证规则
            rules: {
                v_model_idCard: [ // 证件号码
                    {validator: v_model_idCard, required: true, trigger: ['blur', 'change']}
                ],
                v_model_phone: [ // 手机号码
                    {validator: verification.checkPhone, required: true, trigger: ['blur', 'change']}
                ],
                v_model_name: [ // 姓名
                    {validator: v_model_name, required: true, trigger: ['blur', 'change']}
                ],
                v_name: [ // 姓名
                    {validator: v_model_name, required: true, trigger: ['blur', 'change']}
                ],
                v_model_birthday: [ // 出生日期
                    {required: true, message: "请选择生日日期", trigger: ['blur', 'change']}
                ],
                contactName: [
                    {validator: v_model_name, required: true, trigger: ['blur', 'change']}
                ],
                contactPhone: [
                    {validator: verification.checkPhone, required: true, trigger: ['blur', 'change']}
                ],
                adultTicketNumber: [
                    {required: true, message: "请输入成人票号", trigger: ['blur'] }
                ],
                adultCabin: [
                    {required: true, message: "请输入成人舱位", trigger: ['blur']}
                ],


                // 'psgChild.adultTicketNumber': [
                //     {required: true, message: "请输入成人票号", trigger: ['blur', 'change'] }
                // ],

                // adultCabin: [{ validator: validAdult, trigger: "blur" }],
                // email: [
                //     {required: true, message: '请输入邮箱地址', trigger: 'blur' },
                //     {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                // ]
            },
            // 成人数量
            adultNub: 1,
            luggage: "",
            // 儿童数量
            childNub: 0,
            arrowsShow: null,
            dialogVisible: false,
            invoicePrice: 0,
            // 成人价格
            adultPrice: 0,
            // 儿童价格
            childPrice: 0,
            taxes: 0,
            AllPrice: 0,
            PriceText: "",
            rate: 1,
            picList: [],
            image_url_airline_blank_map: `https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`,
            priceList: {},
            priceInfo: {},
            detailFlight: {},
            ruleText: "",
            loadingText: "加载中...",


            isShowTable: false,
            restaurants: [],
            state: '',

            row_list: [], // 选中乘客数据列表

            dialogErrorVisible: false,
            dialogError2Visible: false,
            errorText: '',
            returnSecond: 5,
            returnSetInterval: '',

            dialogSuccessVisible: false, // 申请价提交订单后弹窗
            newOrderNo: '', // 生成的订单号
        };
    },
    computed: {},
    components: {ChangClause, airStop, FlightFrequentTravelerSelector},
    methods: {
        adultTicketNumberVer(row, index, i) { // 手动移除成人票号验证信息
            const formName = 'adultTicketNumber' + index + i;
            if (row.adultTicketNumber) {
                this.$nextTick(() => {
                    this.$refs[formName][0].resetField();
                })
            }
        },
        adultCabinVer(row, index, i) {
            const formName = 'adultCabin' + index + i;
            if (row.adultCabin) {
                this.$nextTick(() => {
                    this.$refs[formName][0].resetField();
                })
            }
        },
        // 获取常旅客table数据
        getTableList() {
            const __this = this;
            //this.loading = true;
            web_tUsfrequenttraveller_listForOrder({type: 1}).then((res) => {
                let newArr = [];
                for(let item of res.tUsFrequentTravellerResults) {
                    // item.isCheckBox = true; //列表是否可选
                    if (item.userType === this.airDataInfo.psgType) {
                        newArr.push(item);
                    } else if (this.airDataInfo.psgType === 3) {
                        newArr.push(item);
                    }
                }
                __this.tableData = newArr;

                __this.pageData.total = this.tableData.length;
                __this.tableDataFilter = this.paging(this.pageData.pageSize, this.pageData.currentPage);
                // __this.loading = false
            }).catch(() => {
                //this.loading = false
            }, new Error(() => {
                //this.loading = false
            }));
        },
        tableFilter(val) { // table 模糊搜索
            this.tableDataFilter = this.tableData.filter(item => {
                let matchName = true; // 姓名 英文名
                let matchIdType = true; // 证件类型
                let matchIdCard = true; // 证件号

                if (val.name) {
                    const keys = val.name
                        .toUpperCase() // 转大写
                        .replace(' ', '') // 删掉空格
                        .split(''); // 切割成 单个字
                    matchName = keys.every(key => item.name.toUpperCase().includes(key)) || keys.every(key => item.enName.toUpperCase().includes(key));
                }
                if (val.idType) {
                    matchIdType = item.idType == val.idType;
                }
                if (val.idCard) {
                    const keys = val.idCard.replace(' ', ''); // 删掉空格
                    matchIdCard = item.idCard.includes(keys);
                }
                return matchName && matchIdType && matchIdCard;
            });

            this.pageData.currentPage = 1;
            this.pageData.pageSize = 10;
            this.pageData.total = this.tableDataFilter.length;
        },
        onReset(formName) { // 重置
            this.$refs[formName].resetFields();
            this.tableFilter(this.searchDate);
        },

        // 本地分页的方法
        paging(size, current) {
            const tableList = JSON.parse(JSON.stringify(this.tableData));
            const tablePush = [];
            tableList.forEach((item, index) => {
                if (size * (current - 1) <= index && index <= size * current - 1) {
                    tablePush.push(item);
                }
            });
            return tablePush;
        },
        // 页数改变事件
        handleSizeChange(size) {
            this.pageData.pageSize = size;
            this.tableDataFilter = this.paging(this.pageData.pageSize, this.pageData.currentPage);
        },
        // 页码改变事件
        handleCurrentChange(current) {
            this.pageData.currentPage = current;
            this.tableDataFilter = this.paging(this.pageData.pageSize, this.pageData.currentPage);
        },

        toggleTable() { // 打开常旅客弹窗
            this.dialogTableVisible = true;
            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) { // 选择旅客
            const __this = this;
            __this.multipleSelection = val;
        },
        //点击行触发，选中或不选中复选框
        handleRowClick(row, column, event) {
            this.$refs.multipleTable.toggleRowSelection(row);
            // console.log("this.selecTestContent", this.selectTestContent);
        },
        // checkSelectable(row) { // 改变列表状态 可选/不可选
        //     return row.isCheckBox; //列表是否可选
        // },
        addPassenger() { // 添加旅客
            const __this = this;
            const multipleSelection = __this.multipleSelection.length; // 选中的乘客个数
            let selectNum = 0; // 已存在的乘客个数
            for (let item of __this.row_list) {
                if (item.v_name && item.v_name !== '') {
                    selectNum = selectNum + 1;
                }
            }

            // let newArr = [];
            // for(let sItem of __this.multipleSelection) { // 选中乘客
                // let flag = true;  //建立标记，判断数据是否重复，true为不重复
                // for(let pItem of __this.row_list) { // 乘客列表
                //     if (sItem.id === pItem.id) { // 判断乘客列表是否存在选中的乘客
                //         flag = false;
                //     }
                // }
                // if (flag) {
                //     newArr.push(sItem);
                // }
            // }

            if (multipleSelection <= 0) {
                __this.$message({type: "warning", message: "请选择常旅客！"});
                return false;
            }

            if (multipleSelection + selectNum > 9) {
                __this.$message({type: "warning", message: "乘客最多只能添加9个！"});
                return false;
            }

            let multipleArr = [];
            for(let sItem of __this.multipleSelection) { // 选中乘客的循环
                let _passenger = {
                    id: sItem.id,
                    ref_name: `aFlightFrequentTravelerSelector_name` + sItem.id,
                    v_model_name: sItem,
                    v_name: sItem.name,
                    v_model_birthday: sItem.birthday,
                    v_model_idCard: sItem.idCard,
                    v_model_idType: sItem.idType,
                    v_model_phone: sItem.phone,
                    v_model_userType: sItem.userType,
                    isChecked: false
                };

                const obj = {
                    adultPsgNo: "",
                    adultTicketNumber: "",
                    adultCabin: "",
                    adultPnr: ""
                };
                let passengerAdultList = [];
                if (__this.airDataInfo.psgType == 2) {
                    passengerAdultList = [obj];
                    __this.airDataInfo.flightType == 2 ? passengerAdultList.push(obj) : "";
                }
                __this.airDataInfo.psgType == 2 ? (_passenger.passengerAdultList = passengerAdultList) : "";
                multipleArr.push(_passenger);
            }

            for (let i = 0, j = 0, flag = true, len = __this.row_list.length; i < len; flag ? i++ : i) {
                if (j >= multipleSelection) break;
                if (__this.row_list[i] && __this.row_list[i].v_name === '') { // 如果没输入就直接移除该form
                    __this.row_list.splice(i, 1);
                    j++;
                    flag = false;
                } else {
                    flag = true;
                }
            }
            __this.row_list = this.deepClone([...multipleArr, ...__this.row_list]);


            __this.passengerVal = __this.row_list.length;
            __this.dialogTableVisible = false; // 关闭选择常旅客弹窗
        },
        passengerMinus(formName, row, index) { // 点击移除乘机人 form
            const __this = this;
            // 移除后改变选中状态
            for(let item of __this.tableDataFilter) { // 改变状态
                if (item.id === row.id) {
                    __this.$refs.multipleTable.toggleRowSelection(item);
                }
            }
            if (__this.passengerVal <= 1) { // 判断只有一个乘客的时候重置表单
                __this.$nextTick(() => {
                    __this.row_list[index].id = 0;
                    __this.row_list[index].v_model_name = null;
                    if (__this.row_list[index].passengerAdultList) {
                        for (let adultItem of __this.row_list[index].passengerAdultList) {
                            adultItem.adultTicketNumber = '';
                            adultItem.adultCabin = '';
                            adultItem.adultPnr = '';
                        }
                    }
                    __this.$refs['userForm' + index][0].resetFields();
                });
                return;
            }

            __this.row_list.splice(index, 1);
            __this.passengerVal = __this.row_list.length;

        },
        passengerPlus() { // 点击添加乘机人 form
            const __this = this;

            if (__this.passengerVal >= 9) {
                __this.$message({
                    type: "warning",
                    message: "最多只能添加9个乘客！"
                });
                return false;
            }
            const _passenger = {
                id: 0,
                ref_name: `aFlightFrequentTravelerSelector_name_0`,
                v_name: '',
                v_model_name: null,
                v_model_userType: Number(__this.airDataInfo.psgType) === 2 ? 2 : 1, // 用户类型 成人
                v_model_idType: 1, //  证件类型
                v_model_idCard: '', // 证件号码
                v_model_birthday: '', // 生日
                v_model_phone: '', // 电话号码
                isChecked: false
            };

            let Obj = {
                adultPsgNo: "",
                adultTicketNumber: "",
                adultCabin: "",
                adultPnr: ""
            };
            let passengerAdultList = [];
            if (__this.airDataInfo.psgType == 2) {
                passengerAdultList = [Obj];
                __this.airDataInfo.flightType == 2 ? passengerAdultList.push(Obj) : "";
            }
            let arr = [];
            __this.airDataInfo.psgType == 2 ? (_passenger.passengerAdultList = passengerAdultList) : "";
            arr.push(_passenger);
            __this.row_list = this.deepClone([...__this.row_list, ...arr]);

            __this.passengerVal = __this.row_list.length;
        },


        __selected_passenger(row, index) {
            const __this = this;
            __this.row_list[index].id = row.id;
            __this.row_list[index].v_model_phone = row.phone;
            __this.row_list[index].v_model_userType = row.userType;
            __this.row_list[index].v_model_idType = row.idType;
            __this.row_list[index].v_model_idCard = row.idCard;
            __this.row_list[index].v_model_birthday = row.birthday;
        },


        getDateWeek(val) {
            let week = new Date(val).getDay();
            let weekString = "";
            switch (week) {
                case 1:
                    weekString = "星期一";
                    break;
                case 2:
                    weekString = "星期二";
                    break;
                case 3:
                    weekString = "星期三";
                    break;
                case 4:
                    weekString = "星期四";
                    break;
                case 5:
                    weekString = "星期五";
                    break;
                case 6:
                    weekString = "星期六";
                    break;
                default:
                    weekString = "星期日";
                    break;
            }
            return weekString;
        },
        async querySearch(queryString, cb, list, index) {
            let res = await this.getAdultTicket(list, index);
            if (res.adultTicketInfos.length > 0) {
                res.adultTicketInfos.map(item => {
                    item.value = item.aduPsgName;
                });
            }
            const restaurants = res.adultTicketInfos;
            const results = queryString
                ? restaurants.filter(this.createFilter(queryString))
                : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return restaurant => {
                if (restaurant.name) {
                    return restaurant.name.indexOf(queryString) != -1;
                } else {
                    return ''
                }

            };
        },
        handleSelect(val, list) {
            list.adultCabin = val.aduCabin;
            list.adultPnr = val.aduPnr;
            list.adultPsgNo = val.aduPsgNo;
            list.adultTicketNumber = val.aduTicketNo;
            this.$forceUpdate();
        },
        setCardType(val) {
            if (val !== 1) {
                this.rules.v_model_idCard[0] = {required: true, message: '请输入证件号码', trigger: ['blur', 'change']}
            } else {
                this.rules.v_model_idCard[0] = {validator: this.v_model_idCard_rules, required: true, trigger: ['blur', 'change']}
            }
        },

        getPriceDetail() {
            setTimeout(() => {
                let data = {
                    adultCount: this.adultNub,
                    childrenCount: this.childNub,
                    sequenceKey: this.detailFlight.sequenceKey
                };
                priceDetail(data).then(res => {
                    this.loading = false
                    this.priceInfo = res.result;
                    this.priceInfo.preferentialExplainCopy = this.priceInfo.preferentialExplain;
                    this.priceInfo.preferentialExplain = JSON.parse(
                        this.priceInfo.preferentialExplain
                    );
                }).catch(() => {
                    this.loading = false
                });
            }, 100);
        },
        // 计算周几
        Getweek(index) {
            let time = this.$moment(index).valueOf();
            let str = [
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六",
                "星期日"
            ];
            let week = Number(this.$moment(time).format("E")) - 1;
            return str[week];
        },
        goRule() {
            this.ProcurementRuleShow = true;
        },
        getTicket(val) {
            let adultList = [],
                childList = [];
            val.map((item, index) => {
                item.policys[0].priceData.map(val => {
                    val.crewType == 1 ? adultList.push(val) : childList.push(val);
                });
            });
            this.priceList = {adultList, childList};
            return new Promise(resolve => {
                resolve(this.priceList);
            });
        },
        // 通过身份证获取生日
        fromIdCard(index) {
            const __this = this;
            let rowList = this.row_list
            let rowItem = rowList[index]
            let idCard = rowItem.v_model_idCard ? rowItem.v_model_idCard : '';
            let birthday = "";
            if (idCard != null && idCard != "") {
                if (idCard.length == 15) {
                    birthday = "19" + idCard.substr(6, 6);
                } else if (idCard.length == 18) {
                    birthday = idCard.substr(6, 8);
                }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
            }
            rowItem.v_model_birthday = birthday;
            // this.row_list = rowList
            this.$set(this.row_list, index, rowItem)
            /*
            * const __this = this;
            let rowList = __this.row_list
            let idCard = __this.row_list[index].v_model_idCard ? __this.row_list[index].v_model_idCard : '';
            let birthday = "";
            if (idCard != null && idCard != "") {
                if (idCard.length == 15) {
                    birthday = "19" + idCard.substr(6, 6);
                } else if (idCard.length == 18) {
                    birthday = idCard.substr(6, 8);
                }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
            }
            rowList[index].v_model_birthday = birthday;
            __this.row_list = rowList*/
        },

        //退改规则
        backRule(val) {
            // if(Object.keys(this.ruleObj).length>0){
            //    if(this.ruleObj.depTime==val.depTime)return
            // }
            this.ruleText = "";
            this.ruleObj = val;
            let data = {
                arrCityPortCode: val.arrAirportCode,
                cabinCode: this.airDataInfo.psgType == 2 ? val.policys[0].cabin.chdCabinCode : val.policys[0].cabin.cabinCode,
                depCityPortCode: val.depAirportCode,
                depDate: val.depDate,
                flightNo: val.flightNo,
                flightType: this.airDataInfo.airType,
                psgType: this.airDataInfo.psgType,
                supplierType: val.policys[0].supplierType,
                policyId: val.policys[0].policyId,
                extData: val.policys[0].extData,
            };
            this.getLuggage(data);
            rule(data).then(res => {
                let refRule = res.refRule.rules;
                let chaRule = res.chaRule.rules;
                if (refRule && chaRule) {
                    refRule.map(item => (item.type = "refRule"));
                    chaRule.map(item => (item.type = "chaRule"));
                    this.ruleText = [refRule, chaRule];
                }
                // this.ruleText = res.chaRule.content;
            });
        },
        //验证手机号
        verifyPassenger(passenger) {
            let list = Object.values(passenger);
            for (let _i = 0; _i < list.length - 1; _i++) {
                for (let _j = _i + 1; _j < list.length; _j++) {
                    if (list[_i].psgType === 1 && list[_j].psgType === 1) {
                        if (list[_i].mobile === list[_j].mobile) {
                            this.$message({
                                type: "warning",
                                message: "乘机人手机号码不能重复！"
                            });
                            return false;
                        }
                    }
                }
            }
            return true;
        },
        //计算票价
        calculate(val) {
            let priceInfo = {
                orderTotal: 0, //订单总价
                settlement: 0, //结算价格
                rebate: 0, //返佣金额
                billingFee: this.detailFlight.billingFee, //开票费用
                taxes: 0 //税金
            };
            let _a = count(val.adultList, "price"); //成人票面价
            let _b = count(val.adultList, "rebatePrice"); //成人结算价
            let _c = count(val.childList, "price"); //儿童票面价
            let _d = count(val.childList, "rebatePrice"); //儿童结算价

            priceInfo.orderTotal =
                _a * this.adultNub + _c * this.childNub + priceInfo.billingFee;
            priceInfo.settlement =
                _b * this.adultNub + _d * this.childNub + priceInfo.billingFee;
            val.adultList.map(item => {
                priceInfo.taxes += Number(item.fuelTax + item.airportTax);
                priceInfo.rebate += Number(item.rebate);
            });
            // priceInfo.orderPayMoney = priceInfo.settlement + priceInfo.taxes;

            function count(list, sumType) {
                let total = 0;
                if (list instanceof Array) {
                    list.forEach(item => {
                        total += item[sumType] + item.airportTax + item.fuelTax;
                    });
                    return total;
                }
            }

            this.priceInfo = priceInfo;
        },
        // 获取信息并计算价格
        async getAirParams(showLoading) {
            let params = JSON.parse(this.$route.query.airdata);
            this.psgTypeOption = [
                {
                    value: 1,
                    label: "成人",
                    disabled: Number(params.psgType) === 2 ? true : false
                },
                {
                    value: 2,
                    label: "儿童",
                    disabled: Number(params.psgType) === 1 ? true : false
                }
            ];
            if (showLoading) {
                this.loading = true
            }

            // this.passenger[0].psgType = Number(params.psgType) === 2 ? 2 : 1;
            let  [err, res] = await awaitWrap(airParams(params))
            if (err) {
                this.loading = false;
                this.$router.go(-1);
            }
            // this.loading = false;
            this.ordersData = res.detail.flights;
            console.log('ordersData', this.ordersData)
            this.detailFlight = res.detail;
            this.getPriceDetail();
            this.getTicket(res.detail.flights).then(list => {
                this.calculate(list);
            });
        },
        getAdultTicket(list, index) {
            let data = {
                arrDate: this.ordersData[index].arrDate,
                // cabin: this.ordersData[index].policys[0].cabin.chdCabinCode,
                depDate: this.ordersData[index].depDate,
                flightNo: this.ordersData[index].flightNo
            };
            return adultTicket(data);
        },
        // 深克隆
        deepClone(obj) {
            let _obj = JSON.stringify(obj);
            let objClone = JSON.parse(_obj);
            return objClone;
        },
        // 计算成人数量
        compAdultNub(data) {
            return data.v_model_userType === 1;
        },
        // 计算儿童数量
        compChildNub(data) {
            return data.v_model_userType === 2;
        },

        // 底部文字部分
        gitPrice: debounce(function(type) { // debounce 添加防抖
            if (type === 1) {
                this.AllPrice = Math.ceil(((this.adultPrice + this.taxes) * this.adultNub).toFixed(2) * 100) / 100 + this.invoicePrice;
            }
            if (type === 2) {
                this.AllPrice = Math.ceil((this.childPrice * this.childNub).toFixed(2) * 100) / 100 + this.invoicePrice;
            }
            this.getAirParams()
        }),
        // 提交表单
        checkout() {
            if (this.airDataInfo.psgType == 2) {
                for (let item of this.passenger) {
                    if (!item.psgNameCn || !item.birthday || !item.mobile || !item.cardNo) {
                        this.$message({message: "请填写乘机人信息", type: "error"});
                        return false;
                    }
                    for (let adultItem of item.passengerAdultList) {
                        if (!adultItem.adultTicketNumber || !adultItem.adultCabin) {
                            return this.$message({message: "请填写乘机人信息", type: "error"});
                        }
                    }
                }
            } else {
                for (let item of this.passenger) {
                    if (item.psgType == 2) {
                        let _s = this.passenger.every(val => {
                            if (val.psgType == 1)  return false;
                            return true;
                        });
                        if (_s) {
                            this.$message({message: "请选择成人", type: "warning"});
                            return false;
                        }
                    }
                }

                for (let item of this.passenger) {
                    if (!item.psgNameCn || !item.birthday || !item.mobile || !item.cardNo) {
                        this.$message({
                            message: "请填写乘机人信息",
                            type: "error"
                        });
                        return false;
                    }
                }
            }
            return true;
        },
        verifyFrom(formName) {
            let statu = true;
            let form = this.$refs[formName];
            form = Array.isArray(form) ? form[0] : form;
            form.validate(valid => {
                if (!valid) {
                    statu = false;
                }
            });
            return statu;
        },
        getLuggage(data) {
            luggage(data).then(res => {
                this.luggage = res.luggage;
            });
        },


        submit() {
            const __this = this;
            for (let i = 0; i < __this.row_list.length; i++) {
                if (!this.verifyFrom(`userForm${i}`)) return;

                if(__this.row_list[i].passengerAdultList) {
                    for (let j = 0; j < __this.row_list[i].passengerAdultList.length; j++) {
                        __this.adultTicketNumberVer(__this.row_list[i].passengerAdultList[j], i, j); // 手动移除一下成人票号验证
                        __this.adultCabinVer(__this.row_list[i].passengerAdultList[j], i, j); // 手动移除一下成人仓位验证
                    }
                }

            }
            if (!this.verifyFrom("ruleForm")) return;

            let passengerArr = [];
            for (let item of __this.row_list) {
                const passengerObj = {
                    gender: 1, // 性别
                    birthday: item.v_model_birthday, // 出生日期，格式：yyyy-MM-dd
                    cardNo: item.v_model_idCard, // 证件号码
                    idCard: item.v_model_idCard, // 证件号码
                    cardType: item.v_model_idType, // 证件类型，1-身份证 2-护照 4-港澳通行证 5-台胞证 6-台湾通行证 7-回乡证 8-军官证 9-其他
                    idType: item.v_model_idType, // 证件类型，1-身份证 2-护照 4-港澳通行证 5-台胞证 6-台湾通行证 7-回乡证 8-军官证 9-其他
                    isSaveFrequent: item.isChecked ? 1 : 0,  // 是否保存至常旅客，0-不保存 1-保存
                    isCheck: item.isChecked ? 1 : 0,  // 是否保存至常旅客，0-不保存 1-保存
                    mobile: item.v_model_phone, // 手机号
                    phone: item.v_model_phone, // 手机号
                    psgNameCn: item.v_name, // 名字
                    name: item.v_name, // 名字
                    psgType: item.v_model_userType, // 乘客类型，1-成人 2-儿童
                    userType: item.v_model_userType, // 乘客类型，1-成人 2-儿童
                    passengerAdultList: item.passengerAdultList
                };
                passengerArr.push(passengerObj);
            }
            this.passenger = passengerArr;

            if (!this.checkout()) return;
            if (!this.verifyPassenger(this.passenger)) return;
            // if (!this.checked) {
            //   return this.$message({
            //     message: "请同意《胤之旅国内旅游机票采购规则》",
            //     type: "error"
            //   });
            // }

            // if (!this.contact.contactName || !this.contact.contactPhone) {
            //   return this.$message({
            //     message: "请填写联系人信息",
            //     type: "error"
            //   });
            // }

            let data = JSON.parse(__this.$route.query.airdata);
            let passengerList = JSON.parse(JSON.stringify(__this.row_list));

            if (__this.airDataInfo.psgType == 2) {
                if (__this.airDataInfo.flightType == 1) {
                    __this.row_list.map(item => {
                      item.adultCabin = item.passengerAdultList[0].adultCabin;
                      item.adultPsgNo = item.passengerAdultList[0].adultPsgNo;
                      item.adultPnr = item.passengerAdultList[0].adultPnr;
                      item.adultTicketNumber = item.passengerAdultList[0].adultTicketNumber;
                    });
                } else {
                    let newList = JSON.parse(JSON.stringify(passengerList));
                    newList.map(item => {
                      item.adultCabin = item.passengerAdultList[0].adultCabin;
                      item.adultPsgNo = item.passengerAdultList[0].adultPsgNo;
                      item.adultTicketNumber = item.passengerAdultList[0].adultTicketNumber;
                    });
                    passengerList.map(item => {
                      item.adultCabin = item.passengerAdultList[1].adultCabin;
                      item.adultPsgNo = item.passengerAdultList[1].adultPsgNo;
                      item.adultTicketNumber = item.passengerAdultList[1].adultTicketNumber;
                    });
                    passengerList = [...newList, ...passengerList];
                }
            }
            let params = {
                // backFlight: data.backFlight,
                // buyerId: this.ordersData[1].policy.supplierId,
                contactEmail: this.contact.contactEmail,
                contactName: this.contact.contactName,
                contactPhone: this.contact.contactPhone,
                contactQQ: "",
                // flightType: data.flightType,
                // goFlight: data.goFlight,
                // hasExpress: 0,
                passengers: this.passenger,
                isOpenUp: this.priceInfo.isOpenUp,
                remark: this.contact.remark,
                fullDecrement: this.priceInfo.fullDecrement,
                preferentialExplain: this.priceInfo.preferentialExplainCopy,
                sequenceKey: this.detailFlight.sequenceKey,
                needPayAmount: this.priceInfo.orderPayMoney,
                fullReductionId: this.priceInfo.fullReductionId,
            };

            //this.loading = true;
            // this.loadingText = "正在确认舱位和价格，请稍后…";
            let loadingInstance = Loading.service({
                text: '正在确认舱位和价格，请稍后…'
            });
            reserve(params)
                .then(
                    res => {
                        let data = res.orderNo;
                        this.newOrderNo = data
                        // this.loading = false;
                        loadingInstance.close()
                        // this.$store.state.ordersData = this.ordersData
                        // this.$store.state.ordersNo = data
                        if (this.detailFlight.flightType === 1) {
                            // 单程航班
                            if (this.ordersData[0].policys[0].policyType === '9999') {
                                // 申请价
                                this.dialogSuccessVisible = true
                                return
                            }
                        }

                        this.$router
                            .push({
                                name: "订单支付",
                                query: {
                                    ordersNo: data
                                }
                            })
                            .catch(err => {
                                this.loading = false;
                                this.$notify.error({
                                    title: "错误",
                                    message: "系统报错"
                                });
                            });
                    },
                    error => {
                        // this.loading = false;
                        loadingInstance.close()
                        /*根据code返回不一样的*/

                        let errorCode = error.data.code
                        if (errorCode === '000102') {
                            this.errorText = '航班价格变动，请重新搜索航班'
                            this.dialogErrorVisible = true
                            this.returnSecond = 5
                            this.returnSetInterval = setInterval(() => {
                                this.returnSecond--
                                if (this.returnSecond <= 0) {
                                    this.returnToSearch()
                                }
                            }, 1000)
                        } else if (errorCode === '000103') {
                            this.errorText = '座位不足，请重新搜索航班'
                            this.dialogErrorVisible = true
                            this.returnSecond = 5
                            this.returnSetInterval = setInterval(() => {
                                this.returnSecond--
                                if (this.returnSecond <= 0) {
                                    this.returnToSearch()
                                }
                            }, 1000)
                        } else if (errorCode === '000105') {
                            this.errorText = '占位失败，请重新预定'
                            this.dialogErrorVisible = true
                            this.returnSecond = 5
                            this.returnSetInterval = setInterval(() => {
                                this.returnSecond--
                                if (this.returnSecond <= 0) {
                                    this.returnToSearch()
                                }
                            }, 1000)
                        }else if (errorCode === '000101') {
                            this.errorText = error.data.msg
                            this.dialogError2Visible = true
                        } else {
                            this.errorText = error.data.msg
                            this.dialogError2Visible = true
                        }
                        /*根据code返回不一样的-end*/
                        /*要隐藏的*/
                        /*if (error.code != "001003") {
                            this.$router.go(-1);
                        }*/
                        /*要隐藏的-end*/
                    }
                )
                .catch(err => {
                    // this.loading = false;
                    loadingInstance.close()
                    this.$router.go(-1);
                });

            if (this.passenger.length > 0) {
                web_tUsfrequenttraveller_saveOrUpdate(this.passenger).catch();  // 下单后保存常旅客
            }
        },

        returnToSearch() {
            // this.detailFlight
            if (!this.dialogErrorVisible) {
                return
            }
            this.dialogErrorVisible = false
            clearInterval(this.returnSetInterval)
            let params = {
                airType: this.detailFlight.flightType, // 航程类型// 航程类型
                time1: moment(this.ordersData[0].depDate).valueOf(), //  出发时间
                time2: this.detailFlight.flightType === 2 ? moment(this.ordersData[1].depDate).valueOf() : null, //  返回时间
                time2Show: this.detailFlight.flightType === 1 ? true : false, // 返回时间是否可用
                psgType: this.airDataInfo.psgType, //  乘机人类型
                ClassType: 0, //舱位等级
                airlines: '', //航空公司
                starCity: this.ordersData[0].depAirportCode,
                starCity1: `${this.ordersData[0].depCityName}(${this.ordersData[0].depAirportCode})`,
                endCity: this.detailFlight.flightType === 2 ? this.ordersData[1].depAirportCode : this.ordersData[0].arrAirportCode,
                endCity1: this.detailFlight.flightType === 2 ? `${this.ordersData[1].depCityName}(${this.ordersData[1].depAirportCode})` : `${this.ordersData[0].arrCityName}(${this.ordersData[0].arrAirportCode})`
            }
            console.log(params)
            this.$router.push({
                name: "机票搜索结果",
                // path: '/air-list',
                query: {
                    airdata: JSON.stringify(params)
                }
            });
        },
        // 继续下单
        continueToOrder() {
            let params = {
                airType: this.detailFlight.flightType, // 航程类型// 航程类型
                time1: moment(this.ordersData[0].depDate).valueOf(), //  出发时间
                time2: this.detailFlight.flightType === 2 ? moment(this.ordersData[1].depDate).valueOf() : null, //  返回时间
                time2Show: this.detailFlight.flightType === 1 ? true : false, // 返回时间是否可用
                psgType: this.airDataInfo.psgType, //  乘机人类型
                ClassType: 0, //舱位等级
                airlines: '', //航空公司
                starCity: this.ordersData[0].depAirportCode,
                starCity1: `${this.ordersData[0].depCityName}(${this.ordersData[0].depAirportCode})`,
                endCity: this.detailFlight.flightType === 2 ? this.ordersData[1].depAirportCode : this.ordersData[0].arrAirportCode,
                endCity1: this.detailFlight.flightType === 2 ? `${this.ordersData[1].depCityName}(${this.ordersData[1].depAirportCode})` : `${this.ordersData[0].arrCityName}(${this.ordersData[0].arrAirportCode})`
            }
            this.dialogSuccessVisible = false
            // 去搜索页
            this.$router.push({
                name: '机票搜索结果',
                query: {
                    airdata: JSON.stringify(params)
                }
            })

        },
        // 去订单详情
        goOrderDetail() {
            this.dialogSuccessVisible = false
            this.$router.push({
                name: 'air-ticket-admin-airDetails',
                query: {
                    ordersNo: this.newOrderNo,
                    psgType: 1
                }
            })
        },
    },
    watch: {
        passengerVal() {
            // 乘客数量改变计算 成人 儿童数量
            this.adultNub = this.row_list.filter(this.compAdultNub).length;
            this.childNub = this.row_list.filter(this.compChildNub).length;

            this.gitPrice(this.psgType); // 乘客数量改变请求计算价格

            let params = JSON.parse(this.$route.query.airdata);
            let passenger = {
                // 出生日期，格式：yyyy-MM-dd
                birthday: "",
                // 证件号码
                cardNo: "",
                // 证件类型，1-身份证 2-护照 4-港澳通行证 5-台胞证 6-台湾通行证 7-回乡证 8-军官证 9-其他
                cardType: 1,
                // 是否保存至常旅客，0-不保存 1-保存
                isSaveFrequent: 0,
                // 手机号
                mobile: "",
                // 名字
                psgNameCn: "",
                v_name: "",
                v_model_name: null,
                // 乘客类型，1-成人 2-儿童
                psgType: Number(params.psgType) === 2 ? 2 : 1,
                v_model_userType: Number(params.psgType) === 2 ? 2 : 1,
                v_model_idType: 1,
                gender: 1
            };
            let Obj = {
                adultPsgNo: "",
                adultTicketNumber: "",
                adultCabin: "",
                adultPnr: ""
            };
            let passengerAdultList = [];
            if (this.airDataInfo.psgType == 2) {
                passengerAdultList = [Obj];
                this.airDataInfo.flightType == 2 ? passengerAdultList.push(Obj) : "";
            }
            let arr = [];
            let length = this.row_list.length;
            if (this.passengerVal === length) {
                return;
            }
            if (this.passengerVal > length) {
                let nub = this.passengerVal - length;
                for (let i = 0; i < nub; i++) {
                    params.psgType == 2 ? (passenger.passengerAdultList = passengerAdultList) : "";
                    arr.push(passenger);
                }
                this.row_list = this.deepClone([...this.row_list, ...arr]);
            }

            if (this.passengerVal < length) {
                let nub = length - this.passengerVal;
                for (let i = 0; i < nub; i++) {
                    this.row_list.pop();
                }
            }
        },

        searchDate: { // 常旅客search
            handler(val) {
                this.tableFilter(val);
            },
            deep: true
        },

        row_list: {
            handler(val) {
                let Obj = {
                    adultPsgNo: "",
                    adultTicketNumber: "",
                    adultCabin: "",
                    adultPnr: ""
                };
                if (this.airDataInfo.psgType == 3) {
                    val.map(item => {
                        if (item.psgType == 2) {
                            let passengerAdultList = [Obj];
                            item.passengerAdultList = passengerAdultList;
                        } else {
                            if (item.passengerAdultList) {
                                delete item.passengerAdultList;
                            }
                        }
                    });
                }


                // 监听数据改变计算成人儿童数量
                this.adultNub = this.row_list.filter(this.compAdultNub).length;
                this.childNub = this.row_list.filter(this.compChildNub).length;
                // Object.keys(this.priceList).length > 0 ? this.calculate(this.priceList) : "";
            },
            deep: true
        }
    },
    created() {
        this.airDataInfo = JSON.parse(this.$route.query.airdata);
        console.log(this.airDataInfo)
        // 初始化数据选择常旅客table数据
        this.getTableList();

        let list = {
            adultPsgNo: "",
            adultTicketNumber: "",
            adultCabin: ""
        };
        // this.airDataInfo.psgType == 2 && this.airDataInfo.flightType == 2
        //   ? (this.row_list[0].passengerAdultList.push(list),
        //     (this.childNub = 1),
        //     (this.adultNub = 0))
        //   : this.airDataInfo.psgType == 2
        //     ? ((this.adultNub = 0), (this.childNub = 1))
        //     : "";
    },
    mounted() {
        this.passengerVal = 1;
        this.getAirParams(true);
        // this.airDataInfo.psgType == 3 ? (this.passengerVal = 2) : "";
        // let flight = JSON.parse(this.$route.query.flight);
        // this.backRule(flight);
        // rate().then(res => {
        //   this.rate = this.rate + res.rate;
        // });

    },
    activated () {
        clearInterval(this.returnSetInterval)
    },
    deactivated() {},
    destroyed () {
        clearInterval(this.returnSetInterval)
    },
};
